export default "__VITE_ASSET__DZWNw0uQ__"